var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-scroll-x-reverse-transition', {
    attrs: {
      "tag": "div",
      "group": ""
    }
  }, _vm._l(_vm.popupOrder, function (item, index) {
    return _c(item.component, {
      key: index,
      tag: "component",
      style: _vm.getStyle(index, item.type),
      attrs: {
        "define": _vm.define,
        "extra": item.extra,
        "type": item.type,
        "payload": item.payload,
        "meta-data": _vm.metaData
      },
      on: {
        "set-meta": function setMeta($event) {
          _vm.metaData = $event;
        }
      }
    });
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }